import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import './Notification.css';

export const NOTIFICATION_TIMEOUT = 5000;

class Notification extends Component {
  componentDidMount() {
    if (this.props.autoHide) {
      setTimeout(() => {
        this.props.setNotification(null);
      }, this.props.timeout || NOTIFICATION_TIMEOUT);
    }
  }

  render() {
    const { content } = this.props;

    return (<div className="notificationBar">
      <span className="notificationText">{content}</span>
      <button
        className="icon icon-cancel closeNotification"
        onClick={() => {
          this.props.setNotification(null);
        }}
      />
    </div>);
  }
}

Notification.propTypes = {
  content: PT.string,
  autoHide: PT.bool,
  setNotification: PT.func,
  timeout: PT.number
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js